import {VAT_EXAMPLES_BY_COUNTRIES, VAT_REGEX_BY_COUNTRIES} from './countries';

/**
 *  Pure validation function returning a boolean
 *
 *  Validate a VAT number depending on the country provided
 */
export function validateVat(value: string, countryCode?: string): boolean {
    if (countryCode && countryCode in VAT_REGEX_BY_COUNTRIES) {
        return VAT_REGEX_BY_COUNTRIES[countryCode as keyof typeof VAT_REGEX_BY_COUNTRIES].test(value);
    }
    return true;
}

export function getVatNumberExampleByCountry(countryCode?: string): string | null {
    return countryCode ? (VAT_EXAMPLES_BY_COUNTRIES[countryCode as keyof typeof VAT_EXAMPLES_BY_COUNTRIES] ?? null) : null;
}
